var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('h1',[_vm._v("Call us at "),_c('a',{attrs:{"href":"tel:+5122225079"}},[_vm._v("512-222-5079")]),_vm._v(" to claim this offer.")])])}]

export { render, staticRenderFns }